import React from "react";
import styles from "./BackBar.module.scss";
import clickableStyles from "./clickable.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface Props {
  title?: string;
  editable: boolean;
  handleClose: () => void;
  previewHandler?: () => void;
  saveHandler?: () => void;
  submitHandler?: () => void;
  hideSubmitButton?: boolean;
  hideSaveButton?: boolean;
  reportModalHandler?: () => void;
  openSettingHandler?: () => void;
}

// ユーザーの設定・編集画面上部のナビゲーションバー
// Navigation bar at the top of the user's settings and editing screen
const BackBar: React.FC<Props> = ({
  title,
  editable,
  handleClose,
  previewHandler,
  saveHandler,
  submitHandler,
  hideSubmitButton,
  hideSaveButton,
  reportModalHandler,
  openSettingHandler,
}) => {
  return (
    <nav className={styles["g-header"]}>
      <div
        onClick={handleClose}
        className={`${styles["g-header__back"]} ${clickableStyles["g-clickable"]}`}
      >
        <FontAwesomeIcon icon={["fas", "chevron-left"]} />
      </div>
      <div className={styles["g-header__title"]}>{title}</div>
      {editable ? (
        <div className={styles["g-header__btn-container"]}>
          {previewHandler ? (
            <button
              type="button"
              onClick={previewHandler}
              className={styles["g-header__preview"]}
            >
              プレビュー
            </button>
          ) : null}
          {saveHandler && hideSaveButton !== undefined ? (
            <button
              type="button"
              onClick={saveHandler}
              className={
                hideSaveButton
                  ? styles["g-header__disabled"]
                  : styles["g-header__save"]
              }
            >
              保存
            </button>
          ) : null}
          {submitHandler && hideSubmitButton !== undefined ? (
            <button
              type="button"
              onClick={submitHandler}
              className={
                hideSubmitButton
                  ? styles["g-header__disabled"]
                  : styles["g-header__publish"]
              }
              disabled={hideSubmitButton}
            >
              公開申請
            </button>
          ) : null}
          {reportModalHandler ? (
            <button
              onClick={reportModalHandler}
              className={styles["g-header__report"]}
            >
              {/* TODO 通報ボタンはデザイン通りだと意外と見にくかったので、配置場所と共に考えたい */}
              <FontAwesomeIcon icon={["fas", "megaphone"]} />
              通報
            </button>
          ) : null}
          {openSettingHandler && (
            <button
              onClick={openSettingHandler}
              className={styles["g-header__setting"]}
            >
              <FontAwesomeIcon icon={["fas", "gear"]} />
            </button>
          )}
        </div>
      ) : (
        <div></div>
      )}
    </nav>
  );
};

export default BackBar;
